var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
var MailDeliveryService = /** @class */ (function (_super) {
    __extends(MailDeliveryService, _super);
    function MailDeliveryService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this._subject = new BehaviorSubject({});
        return _this;
    }
    MailDeliveryService.prototype.init = function () {
        this._subject.next({});
    };
    Object.defineProperty(MailDeliveryService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MailDeliveryService.prototype.getLanguageList = function () {
        this.logger.debug('--getLanguageList');
        this.baseUrl = '/v1/language';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            return data.items;
        }));
    };
    // @TODO 施策タイミングから施策を抜いているだけ。必要であれば別コードとして定義する
    MailDeliveryService.prototype.getSendType = function () {
        this.baseUrl = '/v1/gen/code-m-service?query={"predicateList":[{"name":"code_category_m.name","value":"campaignTiming","operator":"eq"}' +
            ',{"name":"key","value":"campaign","operator":"ne"}],"orderByList":[{"name":"key","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.key, display: item.label });
            }
            return options;
        }));
    };
    MailDeliveryService.prototype.getSendIncludeLower = function () {
        this.baseUrl = '/v1/gen/code-m-service?query={"predicateList":[{"name":"code_category_m.name","value":"sendIncludeLower","operator":"eq"}' +
            ',{"name":"key","value":"campaign","operator":"ne"}],"orderByList":[{"name":"key","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.key, display: item.label });
            }
            return options;
        }));
    };
    MailDeliveryService.prototype.getIsSendable = function () {
        this.baseUrl = '/v1/gen/code-m-service?query={"predicateList":[{"name":"code_category_m.name","value":"isSendable","operator":"eq"}' +
            ',{"name":"key","value":"campaign","operator":"ne"}],"orderByList":[{"name":"key","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.key, display: item.label });
            }
            return options;
        }));
    };
    MailDeliveryService.prototype.getMailDestination = function () {
        this.baseUrl = '/v1/gen/mail-destination-m-service?query={"predicateList":[],"orderByList":[{"name":"cdate","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.title });
            }
            return options;
        }));
    };
    // メール配信用のセグメントは施策利用中のものは使用しない
    MailDeliveryService.prototype.getSegmentM = function () {
        this.baseUrl = '/v1/gen/segment-m-service?query={"orderByList":[{"name":"cdate","direction":"desc"}],"predicateList":[{"name":"segment_set_m.segment_set_id","operator":"isNull"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.segment_id, display: item.segment_title });
            }
            return options;
        }));
    };
    MailDeliveryService.prototype.getTriggerM = function () {
        this.baseUrl = '/v1/gen/trigger-m-service?query={"orderByList":[{"name":"cdate","direction":"desc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.trigger_m_id, display: item.name });
            }
            return options;
        }));
    };
    MailDeliveryService.prototype.getMailDeliveryMList = function () {
        this.baseUrl = '/v1/gen/mail-delivery-m-service?query={"orderByList":[{"name":"cdate","direction":"desc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.id, display: item.title });
            }
            return options;
        }));
    };
    MailDeliveryService.prototype.getMailDeliveryM = function (id) {
        this.baseUrl = '/v1/gen/mail-delivery-m-api/' + id;
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            return data;
        }));
    };
    // MailDeliveryMCompのチェック
    MailDeliveryService.prototype.checkItem = function (rec) {
        var check = true;
        if (!this.colservice.checkVal(rec.sender_email_id)) {
            check = false;
        }
        if (!this.colservice.checkVal(rec.replay_email_id)) {
            check = false;
        }
        if (!this.colservice.checkVal(rec.segment_id)) {
            check = false;
        }
        return check;
    };
    MailDeliveryService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    MailDeliveryService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return MailDeliveryService;
}(ContentBaseService));
export { MailDeliveryService };
//# sourceMappingURL=mail-delivery.service.js.map